import React from "react";
import { get } from "state/jotai";
import { _project } from "state/store.projects";
import styled from "styled-components";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import WebDescription from "components/Pages/WebsiteDescription";
import StyledButton from "components/Pages/StyledButton";

const ImageContainer = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 700px;
  width: 100%;
  height: 420px;
  min-width: 120px;
  border-radius: 16px;
  background: ${({ background }) =>
    background
      ? `url(${background}) lightgray center / cover no-repeat`
      : `#ddd`};
  align-self: stretch;

  /* Tablet + Big Tablet (iPad Pro, large tablets) styles */
  @media (min-width: 600px) and (max-width: 1330px) {
    width: 584px;
    height: 340px;
    margin: 0 auto; /* center horizontally */
  }

  /* Mobile styles */
  @media (max-width: 600px) {
    max-width: 100%;
    width: 100%;
    min-width: 0;
    height: 200px;
  }
`;

const RightLeftDescription = ({
  page,
  DescriptionUnitWithImage,
  DescriptionPropertyWithImage,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTabletOrMid = useMediaQuery("(min-width:600px) and (max-width:1330px)");

  const gallery = get(_project, "gallery");
  const photos = gallery?.[0]?.Data?.ListOfPhotos || [];
// console.log(photos,"sksks")
  const unitImage = page === "propertypage" ? DescriptionUnitWithImage?.[0]?.ImageLink : DescriptionUnitWithImage?.[0]?.ImageLink;
  const areaImage = page === "propertypage" ? DescriptionPropertyWithImage?.[0]?.ImageLink : DescriptionPropertyWithImage?.[0]?.ImageLink;

  const unitDesc = DescriptionUnitWithImage?.[0] || {};
  const propertyDesc = DescriptionPropertyWithImage?.[0] || {};

  const primaryColor = theme.palette.primary.main || "#1976d2";

  const textContainerSX = (isLeft) => ({
    flex: isMobile || isTabletOrMid ? "1 1 100%" : "1 1 340px",
    minWidth: isMobile || isTabletOrMid ? 0 : 470,
    maxWidth: isMobile || isTabletOrMid ? "100%" : 700,
    padding: {
      xs: "0 0 16px 0",
      sm: "0 0 16px 0", // Tablet & big tablet stacked, no side padding
      md: isTabletOrMid
        ? "0" // No side padding for large tablets
        : isLeft
        ? "0 0 16px 40px"
        : "0 40px 16px 0", // Desktop spacing
    },
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    justifyContent: "center", // vertically center text
    height: "100%",
    boxSizing: "border-box",
  });

  const descriptionSx = {
    "& .description-headline": {
      fontSize: isMobile
        ? "1.2rem"
        : "clamp(1.3rem, 2.2vw, 2.1rem)",
    },
    "& .description-text": {
      fontSize: isMobile
        ? "1rem"
        : "clamp(1.1rem, 2vw, 1.4rem)",
    },
    fontSize: isMobile
      ? "1rem"
      : "clamp(1.1rem, 2vw, 1.3rem)",
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: { xs: 5, md: 10 },
        width: "100%",
      }}
    >
      {/* Left Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: isTabletOrMid
            ? "column"
            : { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: 2, md: 0 },
          minHeight: "420px",
        }}
      >
        <ImageContainer background={areaImage} />
        <Box sx={textContainerSX(true)}>
          <WebDescription
            sx={{ mt: 5, ...descriptionSx }}
            headerStyle={{ mb: 2 }}
            header={unitDesc.Headline}
            content={unitDesc.Text}
            overlayColor={primaryColor}
            color="#000"
          />
          {page === "frontpage" && unitDesc.CTAlabel && (
            <Box sx={{ mt: { xs: 3, md: 5 } }}>
              <StyledButton
                Linkto="/unitpage"
                text={unitDesc.CTAlabel}
                showIcon
              />
            </Box>
          )}
        </Box>
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: isTabletOrMid
            ? "column"
            : { xs: "column", md: "row-reverse" },
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: 2, md: 0 },
          minHeight: "420px",
        }}
      >
        <ImageContainer background={unitImage} />
        <Box sx={textContainerSX(false)}>
          <WebDescription
            sx={{ mt: 5, ...descriptionSx }}
            headerStyle={{ mb: 2 }}
            header={propertyDesc.Headline}
            content={propertyDesc.Text}
            overlayColor={primaryColor}
            color="#000"
          />
          {page === "frontpage" && propertyDesc.CTAlabel && (
            <Box sx={{ mt: { xs: 3, md: 5 } }}>
              <StyledButton
                Linkto="/propertypage"
                text={propertyDesc.CTAlabel}
                showIcon
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default RightLeftDescription;
